import styled from '@emotion/styled'
import DropdownMenu from 'components/patterns/DropdownMenu'
import { Paragraph } from 'components/patterns/Typography'

export const Menu = styled(DropdownMenu)`
  align-self: center;
  flex-grow: 0;
`

export const MenuOption = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 5px 12px;
`

export const MenuOptionTitle = styled(Paragraph)`
  align-self: center;
  flex-grow: 1;
  margin-left: 5px;
  color: inherit;
`
